import { motion } from "framer-motion";
import { ShieldCheck, Zap, PackageCheck, MessageCircleMore } from "lucide-react";

const marks = [
  {
    icon: ShieldCheck,
    title: "Authorised Dealer",
    body: "Direct-from-brand supply chain. Anchor by Panasonic authorised — every SKU carries a real warranty card.",
  },
  {
    icon: PackageCheck,
    title: "ISI-marked Only",
    body: "Wires, MCBs, sockets — nothing crosses the counter without an ISI stamp. No copies, no substitutes.",
  },
  {
    icon: Zap,
    title: "1000+ SKUs, One Roof",
    body: "Fans, lights, wires, breakers, conduits, trays, appliances — one visit, complete list ticked.",
  },
  {
    icon: MessageCircleMore,
    title: "WhatsApp in <30 min",
    body: "Ping Kunal directly. Stock check, quotes, and delivery times — usually replied inside the hour.",
  },
];

export default function TrustBar() {
  return (
    <section
      id="trust"
      data-testid="trust-section"
      className="relative py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid md:grid-cols-12 gap-10 items-end mb-14 md:mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="md:col-span-12 font-display text-4xl md:text-6xl tracking-tighter leading-[0.98]"
          >
            Every SKU on our shelf is signed for.{" "}
            <span className="italic font-light text-white/60">
              Nakli ka jhamela nahi — direct dealer, direct warranty.
            </span>
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-4 gap-5">
          {marks.map((m, i) => {
            const Icon = m.icon;
            return (
              <motion.div
                key={m.title}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10%" }}
                transition={{
                  duration: 0.8,
                  delay: i * 0.06,
                  ease: [0.22, 1, 0.36, 1],
                }}
                whileHover={{ y: -6 }}
                data-testid={`trust-card-${i}`}
                className="glass rounded-3xl p-7 relative overflow-hidden hover:border-white/25 transition-[border-color] duration-500"
              >
                <div className="absolute -inset-24 bg-[radial-gradient(circle_at_50%_0%,rgba(29,82,196,0.28),transparent_55%)] opacity-0 hover:opacity-100 transition-opacity duration-500" />
                <div className="relative z-10">
                  <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl grad-bg text-white shadow-[0_10px_30px_-10px_rgba(29,82,196,0.6)] mb-6">
                    <Icon className="h-5 w-5" strokeWidth={1.8} />
                  </span>
                  <h3 className="font-display text-xl md:text-2xl tracking-tight text-white leading-tight">
                    {m.title}
                  </h3>
                  <p className="mt-3 text-white/60 text-sm leading-relaxed">
                    {m.body}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
